<mat-icon
  #tooltipRef="matTooltip"
  [svgIcon]="EsvgFiles.error"
  *ngIf="params && params.value && (params.value.invalidmessage || params.value.error != null)"
  class="red-icon"
  svgIcon="{{EsvgFiles.error}}"
  [matTooltip]="params.value.invalidmessage || params.value.error || 'Ungültiger Wert'"
></mat-icon>
